var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4069_16671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7023 12.287C14.4898 12.3995 14.2711 12.4995 14.0461 12.5807C13.3273 12.8495 12.5711 12.987 11.8023 12.987C8.84609 12.987 6.27109 10.9557 6.27109 8.34321C6.27734 7.63071 6.67109 6.97446 7.29609 6.63696C4.62109 6.74946 3.93359 9.53696 3.93359 11.1682C3.93359 15.787 8.18984 16.2557 9.10859 16.2557C9.60234 16.2557 10.3461 16.112 10.7961 15.9682L10.8773 15.9432C12.6023 15.3495 14.0648 14.187 15.0398 12.6432C15.1148 12.5245 15.0773 12.3745 14.9648 12.2995C14.8836 12.2495 14.7836 12.2432 14.7023 12.287Z",
    fill: "url(#paint0_linear_4069_16671)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M14.7023 12.287C14.4898 12.3995 14.2711 12.4995 14.0461 12.5807C13.3273 12.8495 12.5711 12.987 11.8023 12.987C8.84609 12.987 6.27109 10.9557 6.27109 8.34321C6.27734 7.63071 6.67109 6.97446 7.29609 6.63696C4.62109 6.74946 3.93359 9.53696 3.93359 11.1682C3.93359 15.787 8.18984 16.2557 9.10859 16.2557C9.60234 16.2557 10.3461 16.112 10.7961 15.9682L10.8773 15.9432C12.6023 15.3495 14.0648 14.187 15.0398 12.6432C15.1148 12.5245 15.0773 12.3745 14.9648 12.2995C14.8836 12.2495 14.7836 12.2432 14.7023 12.287Z",
    fill: "url(#paint1_radial_4069_16671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86996 15.4681C6.31371 15.1243 5.83246 14.6681 5.45121 14.1368C3.80746 11.8868 4.30121 8.73057 6.55121 7.08682C6.78871 6.91807 7.03246 6.76182 7.29496 6.63682C7.48871 6.54307 7.81996 6.38057 8.26371 6.38682C8.89496 6.39307 9.48871 6.69307 9.86996 7.19932C10.12 7.53682 10.2637 7.94307 10.27 8.36807C10.27 8.35557 11.8012 3.39307 5.26996 3.39307C2.52621 3.39307 0.269958 5.99932 0.269958 8.28057C0.257458 9.48682 0.519958 10.6868 1.02621 11.7806C2.75121 15.4556 6.95121 17.2556 10.8012 15.9743C9.48246 16.3868 8.04496 16.2056 6.86996 15.4681Z",
    fill: "url(#paint2_linear_4069_16671)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M6.86996 15.4681C6.31371 15.1243 5.83246 14.6681 5.45121 14.1368C3.80746 11.8868 4.30121 8.73057 6.55121 7.08682C6.78871 6.91807 7.03246 6.76182 7.29496 6.63682C7.48871 6.54307 7.81996 6.38057 8.26371 6.38682C8.89496 6.39307 9.48871 6.69307 9.86996 7.19932C10.12 7.53682 10.2637 7.94307 10.27 8.36807C10.27 8.35557 11.8012 3.39307 5.26996 3.39307C2.52621 3.39307 0.269958 5.99932 0.269958 8.28057C0.257458 9.48682 0.519958 10.6868 1.02621 11.7806C2.75121 15.4556 6.95121 17.2556 10.8012 15.9743C9.48246 16.3868 8.04496 16.2056 6.86996 15.4681Z",
    fill: "url(#paint3_radial_4069_16671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78438 9.68686C9.73438 9.74936 9.57812 9.84312 9.57812 10.0431C9.57812 10.2056 9.68437 10.3619 9.87187 10.4931C10.7719 11.1181 12.4656 11.0369 12.4719 11.0369C13.1406 11.0369 13.7906 10.8556 14.3656 10.5181C15.5406 9.83062 16.2656 8.57437 16.2656 7.21187C16.2844 5.81187 15.7656 4.88062 15.5594 4.46812C14.2344 1.87437 11.3719 0.380615 8.26562 0.380615C3.89062 0.380615 0.328125 3.89312 0.265625 8.26812C0.296875 5.98687 2.56562 4.14312 5.26562 4.14312C5.48438 4.14312 6.73438 4.16187 7.89062 4.77437C8.90938 5.31187 9.44688 5.95562 9.81563 6.59937C10.2031 7.26812 10.2719 8.10562 10.2719 8.44312C10.2719 8.77437 10.1031 9.27436 9.78438 9.68686Z",
    fill: "url(#paint4_radial_4069_16671)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78438 9.68686C9.73438 9.74936 9.57812 9.84312 9.57812 10.0431C9.57812 10.2056 9.68437 10.3619 9.87187 10.4931C10.7719 11.1181 12.4656 11.0369 12.4719 11.0369C13.1406 11.0369 13.7906 10.8556 14.3656 10.5181C15.5406 9.83062 16.2656 8.57437 16.2656 7.21187C16.2844 5.81187 15.7656 4.88062 15.5594 4.46812C14.2344 1.87437 11.3719 0.380615 8.26562 0.380615C3.89062 0.380615 0.328125 3.89312 0.265625 8.26812C0.296875 5.98687 2.56562 4.14312 5.26562 4.14312C5.48438 4.14312 6.73438 4.16187 7.89062 4.77437C8.90938 5.31187 9.44688 5.95562 9.81563 6.59937C10.2031 7.26812 10.2719 8.10562 10.2719 8.44312C10.2719 8.77437 10.1031 9.27436 9.78438 9.68686Z",
    fill: "url(#paint5_radial_4069_16671)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4069_16671",
    x1: 3.93384,
    y1: 11.4445,
    x2: 15.0765,
    y2: 11.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C59A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114A8B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4069_16671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0893 11.533) scale(5.96065 5.662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4069_16671",
    x1: 9.8119,
    y1: 6.61469,
    x2: 2.85108,
    y2: 14.1967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078D4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4069_16671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.67675 12.8187) rotate(-81.3826) scale(8.96236 7.24212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4069_16671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.88135 3.34267) rotate(92.2911) scale(12.6595 26.9661)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34C1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2FC2DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2BC3D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36C752"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4069_16671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2694 5.21848) rotate(73.7366) scale(6.08258 4.94731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66EB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66EB6E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4069_16671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.265625 0.380615)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEdge);
export default __webpack_public_path__ + "static/media/microsoft-edge.93b7f79042c05c1a8bdf1e447874ba99.svg";
export { ForwardRef as ReactComponent };